import { Classification } from './classification.types';

export const CLASSIFICATIONS_PREFIX = 'classificationPrefix';

export const getClassificationFilterIds = (values: Record<string, any>) => {
  const classificationIds: string[] = [];
  let newValues = { ...values };

  for (const [key, value] of Object.entries(values)) {
    if (key.startsWith(CLASSIFICATIONS_PREFIX)) {
      classificationIds.push(value);
      newValues = { ...newValues, [key]: undefined };
    }
  }

  return {
    newValues,
    classificationIds: classificationIds.flat(2),
  };
};

export const formatLabel = (option: Classification) => {
  return `${option.code}-${option.name} (${option.classificationType?.name})`;
};
